import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_ctx.calendarSplitData)
    ? (_openBlock(), _createBlock(_component_DataTable, {
        key: 0,
        value: _ctx.calendarSplitData,
        paginator: _ctx.calendarSplitData.length > 20,
        rows: 20,
        class: "p-datatable-sm",
        dataKey: "idCalComposition",
        responsiveLayout: "stack",
        breakpoint: "960px"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "timeByDay.timeDate",
            header: _ctx.$t('cron.date'),
            style: _ctx.calendarManagementDetailTableDescriptor.columnStyle.date,
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("span", null, _toDisplayString(_ctx.getFormattedDate(slotProps.data.timeByDay.timeDate)), 1)
            ]),
            _: 1
          }, 8, ["header", "style"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "day",
            header: _ctx.$t('cron.day'),
            style: _ctx.calendarManagementDetailTableDescriptor.columnStyle.day,
            sortable: true
          }, null, 8, ["header", "style"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "isHoliday",
            header: _ctx.$t('managers.calendarManagement.holiday'),
            style: _ctx.calendarManagementDetailTableDescriptor.columnStyle.checkbox,
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Checkbox, {
                modelValue: slotProps.data[slotProps.column.props.field],
                "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                binary: true
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header", "style"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "pubHoliday",
            header: _ctx.$t('managers.calendarManagement.publicHoliday'),
            style: _ctx.calendarManagementDetailTableDescriptor.columnStyle.checkbox,
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Checkbox, {
                modelValue: slotProps.data[slotProps.column.props.field],
                "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                binary: true
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header", "style"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "listOfAttributes",
            header: _ctx.$t('common.attributes'),
            style: _ctx.calendarManagementDetailTableDescriptor.columnStyle.checkEvent,
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_MultiSelect, {
                class: "kn-material-input",
                modelValue: slotProps.data[slotProps.column.props.field],
                "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                options: _ctx.domains,
                optionLabel: "attributeDomainDescr",
                optionValue: "attributeDomainDescr"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 1
          }, 8, ["header", "style"]),
          (_ctx.canManageCalendar)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                style: _ctx.calendarManagementDetailTableDescriptor.iconColumnStyle
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "pi pi-trash",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.deleteItemConfirm(slotProps.data))
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["style"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "paginator"]))
    : _createCommentVNode("", true)
}